import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaPlus, FaEdit, FaTrash, FaTimes, FaCheck, FaTags } from 'react-icons/fa';
import { theme, t } from '../theme';
import { useConfirm } from './ConfirmProvider';

const CategoriasModal = ({ fecharModal, recarregar }) => {
    const [categorias, setCategorias] = useState([]);
    const [novaCategoria, setNovaCategoria] = useState('');
    const [editando, setEditando] = useState(null);
    const [categoriaEditada, setCategoriaEditada] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const confirm = useConfirm();

    useEffect(() => { carregarCategorias(); }, []);

    const carregarCategorias = async () => {
        try {
            setLoading(true);
            const response = await api.get('/fichas/api/fichas-tecnicas/categorias');
            if (response.data.success) setCategorias(response.data.categorias);
        } catch { setError('Erro ao carregar categorias'); }
        finally { setLoading(false); }
    };

    const adicionarCategoria = async () => {
        if (!novaCategoria.trim()) { setError('Digite o nome da categoria'); return; }
        try {
            const response = await api.post('/fichas/api/fichas-tecnicas/categorias', { nome: novaCategoria.trim() });
            if (response.data.success) { await carregarCategorias(); setNovaCategoria(''); setError(''); recarregar(); }
        } catch (err) { setError(err.response?.data?.message || 'Erro ao adicionar'); }
    };

    const salvarEdicao = async () => {
        if (!categoriaEditada.trim()) { setError('Digite o nome'); return; }
        try {
            const response = await api.put('/fichas/api/fichas-tecnicas/categorias', { categoria_antiga: editando, categoria_nova: categoriaEditada.trim() });
            if (response.data.success) { await carregarCategorias(); setEditando(null); setError(''); recarregar(); }
        } catch (err) { setError(err.response?.data?.message || 'Erro ao editar'); }
    };

    const excluirCategoria = async (categoria) => {
        if (!await confirm(`Excluir "${categoria}"? Fichas ficarão sem categoria.`, { danger: true, confirmText: 'Excluir' })) return;
        try {
            const response = await api.delete('/fichas/api/fichas-tecnicas/categorias', { data: { nome: categoria } });
            if (response.data.success) { await carregarCategorias(); setError(''); recarregar(); }
        } catch (err) { setError(err.response?.data?.message || 'Erro ao excluir'); }
    };

    return (
        <div style={t.overlay}>
            <div style={{ ...t.modal, maxWidth: 480 }}>
                {/* Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ width: 40, height: 40, borderRadius: 12, background: theme.colors.primaryLight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FaTags size={18} color={theme.colors.primary} />
                        </div>
                        <div>
                            <h3 style={{ ...t.h2, margin: 0 }}>Categorias</h3>
                            <p style={{ ...t.subtitle, margin: '2px 0 0' }}>{categorias.length} cadastrada{categorias.length !== 1 ? 's' : ''}</p>
                        </div>
                    </div>
                    <button onClick={fecharModal} style={t.btnIcon}><FaTimes size={16} color={theme.colors.textMuted} /></button>
                </div>

                {error && <div style={t.error}>{error}<button onClick={() => setError('')} style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer', color: theme.colors.danger }}><FaTimes size={12} /></button></div>}

                {/* Adicionar */}
                <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
                    <input value={novaCategoria} onChange={e => setNovaCategoria(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && adicionarCategoria()}
                        placeholder="Nova categoria..." style={{ ...t.input, flex: 1 }} />
                    <button onClick={adicionarCategoria} style={t.btnPrimary}><FaPlus size={12} /> Adicionar</button>
                </div>

                {/* Lista */}
                {loading ? (
                    <div style={{ textAlign: 'center', padding: 24, color: theme.colors.textMuted }}>Carregando...</div>
                ) : categorias.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: 24, color: theme.colors.textMuted }}>Nenhuma categoria cadastrada.</div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        {categorias.map(categoria => (
                            <div key={categoria} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: 10, background: editando === categoria ? theme.colors.bgSection : 'transparent', transition: 'background 0.1s' }}>
                                {editando === categoria ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
                                        <input value={categoriaEditada} onChange={e => setCategoriaEditada(e.target.value)}
                                            onKeyDown={e => { if (e.key === 'Enter') salvarEdicao(); if (e.key === 'Escape') setEditando(null); }}
                                            style={{ ...t.input, flex: 1 }} autoFocus />
                                        <button onClick={salvarEdicao} style={t.btnIcon}><FaCheck size={14} color={theme.colors.success} /></button>
                                        <button onClick={() => setEditando(null)} style={t.btnIcon}><FaTimes size={14} color={theme.colors.textMuted} /></button>
                                    </div>
                                ) : (
                                    <>
                                        <span style={{ fontSize: 14, color: theme.colors.text }}>{categoria}</span>
                                        <div style={{ display: 'flex', gap: 2 }}>
                                            <button onClick={() => { setEditando(categoria); setCategoriaEditada(categoria); }} style={t.btnIcon}><FaEdit size={13} color={theme.colors.info} /></button>
                                            <button onClick={() => excluirCategoria(categoria)} style={t.btnIcon}><FaTrash size={13} color={theme.colors.danger} /></button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {/* Footer */}
                <div style={{ marginTop: 20, textAlign: 'right' }}>
                    <button onClick={fecharModal} style={t.btnSecondary}>Fechar</button>
                </div>
            </div>
        </div>
    );
};

export default CategoriasModal;
